import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, PageSize, StatusCodeActive } from "utils/Constant";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers"
import { useModal } from "context/ModalContext";
import { FilterCard, MainBodyCard, PagesTitle } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import { UserService } from "services/UserService/UserService";
import GridEditButton from "components/Button/GridEditButton";
import GridDeleteButton from "components/Button/GridDeleteButton";
import DataTable from "components/DataTable";
import AddButton from "components/Button/AddButton";

export default function User(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchUserList, fetchDeleteUser, fetchCheckIsAdmin } = UserService()

    const [userList, setUserList] = useState([])
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center",
        },
        {
            key: "username",
            header: "Username"
        },
        {
            key: "fullName",
            header: "Nama"
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.userId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.userId, row.status)} size="w-3" />
                </div>
                
            ),
        },
    ]

    // Function Grid
    const handlePageChange = async (newIndex) => {
        const res = await fetchUserList(username, name, status, PageSize, newIndex)
        if (!res) return 

        const totalData = res?.data?.totalData ?? 0
        const total = Math.max(1, Math.ceil(totalData / PageSize))

        setUserList(res)
        setTotalPages(total)
        setPageIndex(newIndex)
    }

    // Button Event
    const addBtnClick = () => {
        navigate("/setting/user/form?userId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/setting/user/form?userId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = async (id, status) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            const res = await fetchDeleteUser(id, status)
            if (!res) return

            showSuccess({
                onSuccess: async () => {
                    await handlePageChange(pageIndex)
                }
            })
        }
        finally {
            hideLoading()
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                let res = await fetchCheckIsAdmin(localStorage.getItem("Id"))
                if (!res) return
                
                if (res.data.isAdmin === false){
                    localStorage.setItem("IsAdmin", "0")
                    window.location.href = "/"
                } else {
                    await handlePageChange(0)
                }
            }
            finally {
                hideLoading()
            }
        }

        onLoad()
    },[username, name, status])

    return(
        <MainBodyCard>
            <PagesTitle title='User' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Username' width={'w-72'}>
                        <input className="input" value={username} onChange={(e) => { setUsername(e.target.value) }} />
                    </FilterCard>

                    <FilterCard title='Name' width={'w-72'}>
                        <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} />
                    </FilterCard>
                    
                    <FilterCard title='Status' width={'w-32'}>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </FilterCard>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} text='Tambah User' />
            </div>

            <div className="mt-5 hidden sm:block">
                <DataTable
                    columns={columns}
                    data={userList?.data?.listData ?? []}
                />
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </MainBodyCard>
    )
}